import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ValueCol } from './ValueCol';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CheckMarkCol = ({ isChecked, span = 5 }: { isChecked: boolean; span?: number }) => {
  const i = isChecked ? solid('circle-check') : solid('circle-xmark');
  const color = isChecked ? 'green' : 'red';
  return (
    <ValueCol span={span}>
      <FontAwesomeIcon icon={i} size={'lg'} color={color} />
    </ValueCol>
  );
};
